import { render, staticRenderFns } from "./ValidationCheck.vue?vue&type=template&id=6bc6430c&"
import script from "./ValidationCheck.vue?vue&type=script&lang=js&"
export * from "./ValidationCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports